<template>
  <div>
    <center>
      <!-- <v-img height="100%" :src="imageHeadHRM"></v-img> -->
      <v-card  color="#385F73"
            dark max-width="auto">
        <!-- <v-container fluid> -->
          <v-card-actions>

            <v-list-item class="grow">
               <v-list-item-avatar size="80" color="grey darken-3">
            <v-img
              class="elevation-6"
              alt=""
              :src="profile.empImageUrl"
            ></v-img>
          </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    {{ profile.empFull_NameTH }}
                  </v-list-item-title>
                  <v-list-item-title class="text-h6">
                    {{ profile.empCode }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >{{ profile.positionName }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle
                    >{{ profile.masDepartmentName }} :
                    {{ profile.masBranchName }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle v-if="shift"
                    >กะทำงานวันนี้ [{{ shift.shiftCode }}] -
                    {{ shift.shiftDate }}</v-list-item-subtitle
                  >
                </v-list-item-content>
            </v-list-item>
          </v-card-actions>
        <!-- </v-container> -->
      </v-card>
      <!-- <v-container fluid> -->
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense>
          <v-col>
            <v-card style="padding-right: 8px; padding-left: 8px">
              <v-card-text>
                <v-row class="mb-6" justify="center">
                  <v-col md="auto">
                    <v-img class="v-img-margit" :src="require('@/assets/Icon/PleaseSelect.svg')"></v-img>
                  </v-col>
                </v-row>
                <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                  <span class="text-h6 font-weight-light">ประวัติทำรายการ</span>
                </v-card>
                <v-row>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/menu_shiftworkemp.png')"
                      @click="GoShiftWork()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/CheckINOUT.jpg')"
                      @click="GoCheckinHistory()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/AssessmentHis.jpg')"
                      @click="GoAssessmentHistory()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/leaveImg.jpg')"
                      @click="GoLeave()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/tranferShift.jpg')"
                      @click="GoSwitchShift()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/requestLeave.jpg')"
                      @click="GoLeavePrivilege()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img height="100%" :src="require('@/assets/menuOT.png')" @click="GoOt()"></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img height="100%" :src="require('@/assets/adjustIMG.png')" @click="GoAdjust()"></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/UpForHelp.jpg')"
                      @click="GoAssistEmp()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/car_maintenance.png')"
                      @click="GoProblem()"
                    ></v-img>
                  </v-col>
                  <!-- <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/menu_attendance.png')"
                      @click="GoAttendance()"
                    ></v-img>
                  </v-col> -->
                  <!-- <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/punsukText.png')"
                      @click="GoActivityPage()"
                    ></v-img>
                  </v-col> -->
                </v-row>
                <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                  <span class="text-h6 font-weight-light">
                    Covid Help Serivce</span
                  >
                </v-card>
                <v-row>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/GroupAB.png')"
                      @click="GoCovidCheckHistory()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/VaccinationHis.jpg')"
                      @click="GoVaccinationHistory()"
                    ></v-img>
                  </v-col>
                  <!-- <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlCovidRegis" @click="GoRegisterCovid()"></v-img>
                </v-col> -->
                  <!-- <v-col cols="4" sm="4">
                  <v-img height="100%" :src="imageUrlWfh" @click="GoWFH()"></v-img>
                </v-col> -->
                  <!-- <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/Icon/UpForHelp.jpg')"
                      @click="GoSignUpForHelp()"
                    ></v-img>
                  </v-col> -->
                  <v-col cols="4" sm="4"></v-col>
                </v-row>
                <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                  <span class="text-h6 font-weight-light">ข้อมูลพนักงาน</span>
                </v-card>
                <v-row>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="110%"
                      :src="require('@/assets/iconMenu/menu_info.png')"
                      @click="GoHomeEmp()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="110%"
                      :src="require('@/assets/iconMenu/menu_team.png')"
                      @click="GoTeam()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/menu_wal.png')"
                      @click="HomeWelfare()"
                    ></v-img>
                  </v-col>
                </v-row>
                <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                  <span class="text-h6 font-weight-light">เพิ่มเติมระบบ</span>
                </v-card>
                <v-row>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/menu_1.png')"
                      @click="GoPrivacy()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/menu_4.png')"
                      @click="GoUserManual()"
                    ></v-img>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-img
                      height="100%"
                      :src="require('@/assets/iconMenu/menu_system.jpg')"
                      @click="GoIssueProblem()"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      <!-- </v-container> -->
    </center>
  </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      dataItemTeam: [],
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      dataReady: true,
      Eventworks: '',
      shift: null,
      show: true,
      itemsQuota: [],
      itemsLeaveQuota: []
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    localStorage.removeItem('liff_info')
    localStorage.removeItem('liff_ch_register_wfh')

    // this.imageUrl = require('@/assets/Icon/Info.jpg')
    // this.imageUrlTeam = require('@/assets/Icon/Team.jpg')
    // this.imageUrlComingSoon = require('@/assets/Icon/ComingSoon.jpg')
    // this.imageUrlCheckINOUT = require('@/assets/Icon/CheckINOUT.jpg')
    // this.imageUrlReport = require('@/assets/Icon/Report.jpg')
    // this.imageUrlRiskAssessment = require('@/assets/Icon/RiskAssessment.jpg')
    // this.imageUrlCovidHis = require('@/assets/Icon/CovidHis.jpg')
    // this.imageUrlRegis = require('@/assets/Icon/Regis.jpg')
    // this.imageUrlWfh = require('@/assets/Icon/GroupAA.png')
    // this.imageUrlAssessmentHis = require('@/assets/Icon/AssessmentHis.jpg')
    // this.imageUrlVaccinationHis = require('@/assets/Icon/VaccinationHis.jpg')
    // this.imageUrlCovidRegis = require('@/assets/Icon/CovidRegis.jpg')
    // this.imageUrlUpForHelp = require('@/assets/Icon/UpForHelp.jpg')
    // this.imageUrlCovidCheck = require('@/assets/Icon/GroupAB.png')
    // this.imageUrlPrivacy = require('@/assets/Icon/imeprivacy.png')
    // this.imageUrlWelfare = require('@/assets/Icon/imewelfare.png')
    // this.imageSelect = require('@/assets/Icon/PleaseSelect.svg')
    // this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    // this.imagepadlock = require('@/assets/Icon/padlock.png')
    // this.imageschedule = require('@/assets/Icon/schedule.png')
    // this.imageinsurance = require('@/assets/Icon/health-insurance.png')
    // this.imageshifttransfer = require('@/assets/Icon/tranferShift.jpg')
    // this.imageLeave = require('@/assets/Icon/leaveImg.jpg')
    // this.imageRequestLeave = require('@/assets/Icon/requestLeave.jpg')
    // this.imageTeam = require('@/assets/Icon/TeamHome.jpg')
    // this.imageOt = require('@/assets/menuOT.png')
    // this.Eventworks = require('@/assets/WEventPS.png')
    // console.log('image', this.imageUrl)
    await this.checkLiffLogin()
    // await this.makeRequest()
  },
  methods: {
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({ redirectUri: window.location })
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async (profileLine) => {
          _this.form.userLineuserId = profileLine.userId
          _this.form.userLinepictureUrl = profileLine.pictureUrl
          await _this.getDataEmp(_this.form)
        })
        .catch(function (error) {
          alert('Error getting profile: ' + error)
        })
    },
    async getProfile_dev () {
      let _this = this
      _this.form.userLineuserId = _this.main_profile.userLineuserId
      _this.form.userLinepictureUrl = _this.main_profile.pictureUrl
      await _this.getDataEmp(_this.form)
    },
    async getDataEmp (dt) {
      this.dataReady = true
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/lineid?userLineuserId=' +
            dt.userLineuserId
        )
        .then(async (response) => {
          console.log(response.data)
          if (response.data[0].empCode) {
            this.profile = response.data[0]
            await this.makeRequest(this.DNS_IP + '/' + this.profile.empImageUrl)

            localStorage.setItem('liff_info', JSON.stringify(this.profile))
            await this.getDataShift(this.profile.empCode)

            await this.navigation()
            this.dataReady = false

            //
          } else {
            this.$swal(
              'ไม่พบรหัสพนักงาน',
              'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล',
              'error'
            )
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.$router.push('/Liff/LoginInfo')
          this.dataReady = false
        })
    },
    // async ch_register_wfh (dt) {
    //   this.dataReady = true
    //   this.registerWFHItem = []
    //   await axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP + "/ch_register_wfh/getEmpCode?empCode=" + dt.empCode
    //     )
    //     .then(async (response) => {
    //       // this.registerWFHItem = response.data
    //       localStorage.setItem(
    //         'liff_ch_register_wfh',
    //         JSON.stringify(response.data)
    //       )
    //     })
    //     // eslint-disable-next-line handle-callback-err
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
    async navigation () {
      if (this.$route.query.page) {
        // console.log(this.$route.query.page)
        await this.$router.push('/Liff/' + this.$route.query.page)
      }
    },
    async getDataShift (empCode) {
      this.dataReady = true
      var shift = await axios.get(
        this.DNS_IP + '/shift_import/getByEmpCode?empCode=' + empCode
      )
      if (shift['data']) {
        this.shift = shift['data']
      }
    },
    makeRequest (imageUrl) {
      if (imageUrl) {
        fetch(imageUrl)
          .then((response) => {
            this.profile.empImageUrl = imageUrl
            console.log('imageUrl: ', imageUrl) // 👉️ 200
            console.log('status: ', response.status) // 👉️ 200
            console.log(response)
          })
          .catch((err) => {
            this.profile.empImageUrl = this.form.userLinepictureUrl
            console.log(err)
          })

        console.log('userLinepictureUrl: ', this.form.userLinepictureUrl) // 👉️ 200
        console.log('imageUrl: ', this.profile.empImageUrl) // 👉️ 200
      }
    },
    // async getDataLeaveType (profile) {
    //   // Clear Data ทุกครั้ง

    //   this.itemsQuota = []
    //   var itemsQuota = await axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP + '/leave_quota/position_lavel_get?positionTypeCode=' +
    //     profile.positionTypeCode,
    //       {
    //         headers: {
    //           'Application-Key': this.$session.getAll().ApplicationKey
    //         }
    //       }
    //     )
    //   if (itemsQuota['data']) {
    //     console.log('itemsQuota', itemsQuota['data'])

    //     await this.getDataLeave(profile.empCode)
    //   }
    // },
    // async getDataLeave (empCode) {
    //   // Clear Data ทุกครั้ง

    //   this.itemsLeaveQuota = []
    //   var itemsLeaveQuota = await axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP + '/leave_data/getByEmpWaitingApproveYear?empCode=' +
    //     empCode,
    //       {
    //         headers: {
    //           'Application-Key': this.$session.getAll().ApplicationKey
    //         }
    //       }
    //     )
    //   if (itemsLeaveQuota['data']) {
    //     console.log('itemsLeaveQuota', itemsLeaveQuota['data'])
    //   }
    // },
    GoInfo () {
      this.$router.push('/Liff/Info')
    },
    GoShiftWork () {
      this.$router.push('/Liff/ShiftWorkEmp')
    },
    GoCheckinHistory () {
      this.$router.push('/Liff/CheckinHistory')
    },
    GoWFH () {
      this.$router.push('/Liff/RegisterWFH')
    },
    GoCheckINOUT () {
      this.$router.push('/Liff/Checkin')
    },
    GoCovid () {
      this.$router.push('/Liff/MenuCovid')
    },
    GoReport () {
      this.$router.push('/Liff/MenuReport')
    },
    GoRiskAssessment () {
      this.$router.push('/Liff/RiskAssessment')
    },
    GoAssessmentHistory () {
      this.$router.push('/Liff/AssessmentHistory')
    },
    GoCovidCheckHistory () {
      this.$router.push('/Liff/CovidCheckHistory')
    },
    GoVaccinationHistory () {
      this.$router.push('/Liff/VaccinHistory')
    },
    GoRegisterCovid () {
      this.$router.push('/Liff/RegisterCovid')
    },
    GoSignUpForHelp () {
      this.$router.push('/Liff/CovidAddHelp')
    },
    GoLeave () {
      this.$router.push('/Liff/LeaveHistory')
    },
    GoLeavePrivilege () {
      this.$router.push('/Liff/HomeSpecialRequest')
    },
    GoOt () {
      this.$router.push('/liff/OTRequest')
    },
    GoAdjust () {
      this.$router.push('/liff/AdjustCheckInCheckOut')
    },
    GoCardWelfare () {
      this.$router.push('/Liff/SocialInsurance')
    },
    GoPrivacy () {
      this.$router.push('/Liff/Privacy')
    },
    GoHomeEmp () {
      this.$router.push('/Liff/HomeEmployee')
    },
    GoTeam () {
      this.$router.push('/Liff/Team')
    },
    GoSwitchShift () {
      this.$router.push('/Liff/ShiftsTransfer')
    },
    GoHomeEvent () {
      this.$router.push('/Liff/HomeEvent')
    },
    HomeWelfare () {
      this.$router.push('/Liff/HomeWelfare')
    },
    GoFamily () {
      this.$router.push('/Liff/EmpFamily')
    },
    GoInfomation () {
      this.$router.push('/Liff/EmpInfomation')
    },
    GoUpdateAddress () {
      this.$router.push('/Liff/EmpAddress')
    },
    GoIssueProblem () {
      this.$router.push('/Liff/IssueProblem')
    },
    GoUserManual () {
      this.$router.push('/Liff/ManualApp')
    },
    GoActivityPage () {
      this.$router.push('/Liff/RegisterEvent')
    },
    GoAssistEmp () {
      this.$router.push('/Liff/EmployeeAddHelp')
    },
    GoProblem () {
      this.$router.push('/Liff/IssueProblemCars')
    },
    GoAttendance () {
      this.$router.push('/Liff/Attendance')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/Home.vue